exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".comment[data-v-2b994065]{min-height:20px;transition:all .2s;overflow:hidden}.comment__text[data-v-2b994065]{font-size:18px;line-height:20px;color:#59d;font-weight:700;cursor:pointer}.comment .t-form__input[data-v-2b994065]{max-width:900px}.comment .t-form__input textarea[data-v-2b994065]{background-color:transparent}.comment-enter-active[data-v-2b994065]{transition:all .3s}.comment-leave-active[data-v-2b994065]{position:absolute;transition:all .2s}.comment-enter[data-v-2b994065],.comment-leave-to[data-v-2b994065]{opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2b994065","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?indentedSyntax!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/templates/components/ui/comment.vue
// module id = 448
// module chunks = 0